<template>
  <b-overlay :show="loading" rounded="lg" spinner-variant="gold">
    <div class="container-documents">
      <b-row class="content-card">
        <b-col class="px-0">
          <div class="text-right">
            <b-input-group class="mt-3">
              <b-form-input
                v-model="filterDoc"
                @keyup="searchDoc()"
                placeholder="Filtrar por descripción"
                autocomplete="off"
                name="filterDoc"
              ></b-form-input>
              <b-input-group-append>
                <b-button variant="customer" class="px-5" @click="searchDoc()"
                  >Buscar</b-button
                >
              </b-input-group-append>
            </b-input-group>
            <br />
            <b-button
              variant="outline-secondary"
              class="mb-3"
              size="sm"
              @click="
                filterDoc = '';
                searchDoc();
              "
            >
              Limpiar búsqueda
            </b-button>
          </div>
          <b-table-simple condensed borderless hover>
            <tbody>
              <b-tr
                class="d-none d-lg-table-row text-center text-white"
                style="background-color: #707070"
              >
                <b-th><b>Descripción</b></b-th>
                <b-th><b>Fecha</b></b-th>
                <b-th><b>Documentos</b></b-th>
              </b-tr>
              <template v-for="(document, key) in pageOfItems">
                <b-tr
                  :key="'doc-tr' + key"
                  class="d-none d-lg-table-row payment-table"
                >
                  <b-td>
                    <h5 v-if="document.name">
                      {{ document.name }}
                    </h5>
                    <h5 v-else>
                      {{ document.type }} Nº
                      <b>{{
                        isNaN(document.number)
                          ? document.number
                          : new Intl.NumberFormat("es-CL").format(
                              document.number
                            )
                      }}</b>
                    </h5>
                  </b-td>
                  <b-td>
                    {{ document.date }}
                  </b-td>
                  <b-td>
                    <b-button
                      :href="document.url"
                      variant="customer"
                      squared
                      target="_blank"
                      download
                      >Descargar</b-button
                    >
                  </b-td>
                </b-tr>
                <b-tr :key="'small-doc-tr' + key" class="d-lg-none">
                  <b-td>
                    <small>{{ document.type }}</small
                    ><br />
                    <b
                      >Nº
                      {{
                        isNaN(document.number)
                          ? document.number
                          : new Intl.NumberFormat("es-CL").format(
                              document.number
                            )
                      }}</b
                    ><br />
                    <small>{{ document.date }}</small>
                  </b-td>
                  <b-td class="align-middle text-right">
                    <b-button
                      :href="document.url"
                      variant="customer"
                      squared
                      target="_blank"
                      download
                      >Descargar</b-button
                    >
                  </b-td>
                </b-tr>
              </template>
            </tbody>
          </b-table-simple>
        </b-col>
      </b-row>
      <div class="text-right row" v-if="documents">
        <div class="col-md-6">
          <select
            v-model="pageSize"
            class="form-control float-left"
            @change="changeSize"
          >
            <option :value="10">10</option>
            <option :value="20">20</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
        </div>
        <div class="col-md-6">
          <pagination
            v-model="page"
            :per-page="pageSize"
            :records="documents.length"
            @paginate="onChangePage"
            :styles="customStyles"
            :labels="customLabels"
            ref="pagination"
            id="pagination"
            class="float-right"
            :options="paginatorOptions"
          ></pagination>
        </div>
      </div>
    </div>
  </b-overlay>
</template>
<script>
export default {
  name: "documents",
  components: {},
  props: {
    asset_id: null,
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      document_tab_index: 0,
      loading: true,
      theme: "bootstrap4",
      pageOfItems: [],
      Apartment: null,
      documents: [],
      documentsOriginal: [],
      filterDoc: "",
      paginatorOptions: {
        texts: { count: "" },
      },
      customStyles: {
        li: {
          display: "inline-block",
        },
        a: {
          color: "black",
        },
      },
      customLabels: {
        first: "<<",
        last: ">>",
        previous: "<",
        next: ">",
      },
    };
  },
  beforeMount() {
    this.Apartment = this.$store.getters.getApartmentById(
      parseInt(this.asset_id)
    );
    this.setDocuments();
  },
  methods: {
    setDocuments() {
      this.axios
        .get("contracts/" + this.Apartment.contract_id + "/get_documents")
        .then((result) => {
          this.loading = false;
          this.documents = result.data.documents;
          if (this.customer == "clab") {
            this.documents = result.data.documents.filter(
              (doc) => !["Planta", "Catálogo"].includes(doc.type)
            );
          }
          this.documentsOriginal = this.documents;
          this.pageOfItems = this.documents.slice(
            (this.page - 1) * this.pageSize,
            this.page * this.pageSize
          );
        });
    },
    onChangePage(page) {
      this.pageOfItems = this.documents.slice(
        (page - 1) * this.pageSize,
        page * this.pageSize
      );
    },
    searchDoc() {
      this.documents = this.documentsOriginal.filter((doc) => {
        return doc.name.toLowerCase().includes(this.filterDoc.toLowerCase());
      });
      this.pageOfItems = this.documents.slice(
        (this.page - 1) * this.pageSize,
        this.page * this.pageSize
      );
    },
    changeSize() {
      this.page = 1;
      this.pageOfItems = this.documents.slice(
        (this.page - 1) * this.pageSize,
        this.page * this.pageSize
      );
    },
  },
  computed: {
    customer() {
      return this.$store.getters.getCustomer;
    },
  },
};
</script>
<style></style>
